export default __webpack_public_path__ + "static/media/dashboard_icon.3da18a45.svg";